import { Breadcrumb, Button } from "pepsico-ds";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../routes/paths";
import PageHeader from "../../common/PageStructure/PageHeader";
import PageWrapper from "../../common/PageStructure/PageWrapper";

/**
 * Component for viewing configuration pages with common structure and functionality
 */
const ConfigurationViewPage = ({
  configKey,
  headerText,
  description,
  breadcrumbPath,
  children,
  editPath,
}) => {
  const navigate = useNavigate();

  const navigateToEditSettings = () => {
    navigate(editPath);
  };

  const navigateToManagement = () => {
    navigate(`/${paths.system_setting}`);
  };

  return (
    <PageWrapper>
      <Breadcrumb breadcrumbs={breadcrumbPath} activeIndex={1} />
      <PageHeader headerText={headerText} />

      <div className={`${configKey}-card`}>
        <h4 className="$color-text-primary">{description}</h4>
        <div className="values-container">{children}</div>
      </div>

      <div className="button-container">
        <Button
          size="medium"
          text="Back to System Setting"
          variant="secondary"
          className="mr-2"
          onClick={navigateToManagement}
        />
        <Button
          size="medium"
          text="Edit"
          variant="primary"
          iconTrailing="arrow_circle_right"
          onClick={navigateToEditSettings}
        />
      </div>
    </PageWrapper>
  );
};

ConfigurationViewPage.propTypes = {
  configKey: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  breadcrumbPath: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string,
    })
  ).isRequired,
  children: PropTypes.node.isRequired,
  editPath: PropTypes.string.isRequired,
};

export default ConfigurationViewPage;
